import { InfoTooltip } from '@/components/poppers/Tooltip/InfoTooltip';
import { COLORS } from '@/styles/tokens/colors';

/** Shared accuracy disclaimer for AI chat headers. */
export function ChatDisclaimerTooltip() {
  return (
    <InfoTooltip
      title="Luminary AI can make mistakes. Please double check all outputs for
          accuracy."
      iconProps={{ sx: { color: COLORS.NAVY['700'], cursor: 'default' } }}
    />
  );
}
